<template>
  <div id="jumbo" class="container-fluid" data-v-gold00001></div>
  <div id="art" class="container">
    <h1>Gold Series</h1>

    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Black_gold_q.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal1"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Black Gold (2026)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Pure_gold_q.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal2"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pure Gold (2026)</p>
      </div>
    </div>

    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/White_gold_q.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal3"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">White Gold (2026)</p>
      </div>
  
    </div>
  </div>

  <!-- One carousel per artwork, matching the available views in public/img. -->
  <div
    class="modal fade"
    id="exampleModal1"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls1"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img src="/img/Black_Gold_1.jpg" class="img-fluid" style="max-height: 70vh" alt="Black Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/Black_Gold_2.jpg" class="img-fluid" style="max-height: 70vh" alt="Black Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/Black_Gold_3.jpg" class="img-fluid" style="max-height: 70vh" alt="Black Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/Black_Gold_4.jpg" class="img-fluid" style="max-height: 70vh" alt="Black Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/Black_Gold_5.jpg" class="img-fluid" style="max-height: 70vh" alt="Black Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/Black_Gold_6.jpg" class="img-fluid" style="max-height: 70vh" alt="Black Gold" />
              </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls1" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls1" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Black Gold, Acryl on Canvas, 80 x 100 cm (2026)</div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="exampleModal2"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls2"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img src="/img/Pure_gold.jpg" class="img-fluid" style="max-height: 70vh" alt="Pure Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/Pure_Gold_2.jpg" class="img-fluid" style="max-height: 70vh" alt="Pure Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/Pure_Gold_3.jpg" class="img-fluid" style="max-height: 70vh" alt="Pure Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/Pure_Gold_4.jpg" class="img-fluid" style="max-height: 70vh" alt="Pure Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/Pure_Gold_5.jpg" class="img-fluid" style="max-height: 70vh" alt="Pure Gold" />
              </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls2" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls2" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pure Gold, Acryl on Canvas, 80 x 100 cm (2026)</div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="exampleModal3"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls3"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img src="/img/White_Gold_1.jpg" class="img-fluid" style="max-height: 70vh" alt="White Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/White_Gold_2.jpg" class="img-fluid" style="max-height: 70vh" alt="White Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/White_Gold_3.jpg" class="img-fluid" style="max-height: 70vh" alt="White Gold" />
              </div>
              <div class="carousel-item">
                <img src="/img/White_Gold_4.jpg" class="img-fluid" style="max-height: 70vh" alt="White Gold" />
              </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls3" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls3" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">White Gold, Acryl on Canvas, 100 x 100 cm (2026)</div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Gold",
};
</script>
